import React from "react";
import { Routes, Route, Outlet } from "react-router-dom";
import MobileShort from "./MobileShort";
import Referrer from "./Referrer";

export default class App extends React.Component {

      public render(): React.ReactNode {
            return (
                  <Routes>
                        <Route path="/" element={<Layout />}>
                              <Route index element={<Home />} />
                              <Route path="thegent" element={<MobileShort />} />
                              <Route path="home" element={<Home />} />
                              <Route path="ref" element={<Referrer />} >
                                    <Route path="*" />
                              </Route>

                        </Route>
                  </Routes>
            );
      }

}

function Home() {
      return (
            <></>
      );
}

function Layout() {
      return (
            <div>

                  <hr />

                  {/* An <Outlet> renders whatever child route is currently active,
          so you can think about this <Outlet> as a placeholder for
          the child routes we defined above. */}
                  <Outlet />
            </div>
      );
}